import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Content = tw.div`mt-16`;
const ControlButton = styled(PrimaryButtonBase)`
  ${tw`mt-4 sm:mt-0 first:ml-0 ml-6 rounded-full p-2`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`,
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;
const DividerTextContainer = tw.div`my-12 border-b text-center relative`;
const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-auto sm:text-lg rounded-none w-full rounded `;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default (data) => {
  const navigate = useNavigate();
  // const cards = [
  //   {
  //     id: "sjbjs778sjhbhv",
  //     imageSrc:
  //       "https://firebasestorage.googleapis.com/v0/b/mulkinvest-613c0.appspot.com/o/AlaToo.png?alt=media&token=1d24421a-8edb-44f1-9c30-11b570a36d8a",
  //     title: "Ala Too Towers",
  //     description:
  //       "Ala Too Towers is a mixed-use luxury real estate development project in Bishkek, the capital city of Kyrgyzstan.",
  //     locationText: "Kyrgyzstan",
  //     pricingText: "USD 158 million",
  //     minInvestment: "$100,000",
  //     status: true,
  //     subtitle: "Active",
  //     returns: "44.8%",
  //   },
  //   {
  //     id: "sjvnkl33048dsf",
  //     imageSrc:
  //       "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&h=1024&w=768&q=80",
  //     title: "Soho Towers",
  //     description:
  //       "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
  //     locationText: "Ibiza, Spain",
  //     pricingText: "Coming Soon",
  //     minInvestment: "Not Disclosed",
  //     subtitle: "Coming Soon",
  //     status: false,
  //     returns: "Not Disclosed",
  //   },
  //   {
  //     id: "ssdcsc98978sdc",
  //     imageSrc:
  //       "https://images.unsplash.com/photo-1549294413-26f195200c16?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&h=1024&w=768&q=80",
  //     title: "Wyatt Residency",
  //     description:
  //       "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
  //     locationText: "Palo Alto, CA",
  //     pricingText: "Coming Soon",
  //     minInvestment: "Not Disclosed",
  //     status: false,
  //     subtitle: "Coming Soon",
  //     returns: "Not Disclosed",
  //   },
  // ];

  const series = [
    {
      name: "Investment",
      data: [
        100000, 200000, 150000, 150000, 200000, 100000, 200000, 150000, 100000,
      ],
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "Returns Trends by Month",
      align: "left",
    },
    colors: ["#8403fc"],
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
  };

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Our Projects</HeadingTitle>
          <HeadingDescription>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </HeadingDescription>
        </HeadingInfoContainer>

        <Content>
          {data.data.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
                <Subtitle>
                  {" "}
                  Minimum Investment: {card.minimumInvestment}
                </Subtitle>
                <Subtitle>
                  {" "}
                  Average Annual Returns: {card.targetedAnnualCashYield}
                </Subtitle>

                <DividerTextContainer></DividerTextContainer>
                {card?.status ? (
                  <PrimaryButton
                    onClick={() =>
                      navigate(`/all-list/${card.id}`, { state: card })
                    }
                  >
                    See More Details
                  </PrimaryButton>
                ) : (
                  <Link>Coming Soon</Link>
                )}
                <DividerTextContainer></DividerTextContainer>
                {card?.status ? (
                  <ReactApexChart
                    options={options}
                    series={series}
                    type="line"
                    height={200}
                  />
                ) : null}
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
